import {query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {
    AInesEmployeeQualificationExperiencesType,
    AInesEmployeeQualificationType,
    Employee,
    EmployeeContract, EmployeeQualification
} from "@/graphql/generated/graphql";
import {CalendarMonth} from "@/helper/calendar/calendarMonth";
import { clientFragment, houseFragment } from "./jobsite";
import { jobsiteFragment } from "./jobsite";

import {userFragment} from "@/helper/auth";
import {kapitelDateString} from "@/graphql/kapitelTypes";
import date from "@/helper/datetime/date";
import {listFormat} from "@/helper/amountFormatter";
import {graphql} from "@/graphql/generated";


export async function fetchEmployee(): Promise<Employee> {
    const result = await query(
        graphql(` query getEmployee {
            employee {
                id,
                name,
                slug,
                demo,
                profilePicturePath,
                contracts {
                    validFrom,
                    validTo,
                    monthlyHours
                },
                firstContract {
                    validFrom,
                    validTo,
                    monthlyHours
                },
                aZK {
                    validMonth,
                    value
                },
                targetAZK{
                    value
                },
                user {
                    ...UserFragment
                },
                offerableQualifications {
                    id,
                    label
                }
                sedCardSufficientlyFilled
            }
        }`)
    )

    return result.data.employee
}

export async function fetchEmployees(): Promise<Employee[]> {
    const result = await query(
        graphql(`
        
        
        
        
        query getEmployees {
            employees {
                id,
                name,
                profilePicturePath,
                user {
                    ...UserFragment
                },
                aZK {
                    validMonth
                    value
                }
                favoriteJobsites {
                    ...JobsiteFragment
                    client {
                        ...ClientFragment
                    }
                    house {
                        ...HouseFragment
                    }
                }
                contracts {
                    validFrom,
                    validTo,
                    monthlyHours
                },
                currentContract {
                    monthlyHours
                },
                employeeQualification {
                    qualification
                    specialisation
                    experiences
                }
            }   
        }`)
    )

    return result.data.employees
}

export async function fetchEmployeeContractFor(month: CalendarMonth): Promise<EmployeeContract> {
    const result = await query(
        graphql(`query getEmployeeContract($month:KapitelDateImmutable!) {
            employee {
                contract(month: $month) {
                    validFrom,
                    validTo,
                    monthlyHours
                },
            }
        }`),
        {
            month: month.begin
        }
    )

    return result.data.employee.contract
}

export function employeeContractValidOn(contract: EmployeeContract, onDate: kapitelDateString) {
    return date.isBefore(contract.validFrom, onDate) && (!contract.validTo || date.isAfter(date.endOfMonth(contract.validTo), onDate))
}
export function employeeContractValidToday(contract: EmployeeContract) {
    return employeeContractValidOn(contract, date.getToday())
}
export function employeeContractIsOrWillBeValid(contract: EmployeeContract) {
    return (!contract.validTo || date.isAfter(date.endOfMonth(contract.validTo), date.getToday()))
}

export function formatEmployeeQualification(eq: EmployeeQualification) {
    let result = eq.qualification ?? ''

    if (eq.qualification == AInesEmployeeQualificationType.FachGkp) {
        result = result + ' ' + eq.specialisation
    }

    if (eq.experiences && eq.experiences?.length > 0) {
        result = result + ' Erf. ' + listFormat(eq.experiences ?? [], {style: 'short'}, 'en')
    }

    return result
}
